/* @flow */
import OrganizationProfileTeachers from 'collections/OrganizationProfileTeachers';
import capitalize from 'utils/capitalize';
import { cloneDeep } from 'lodash';
import Organization from 'entities/Organization';

/**
 * A subset of properties of Organization, from an unauthenticated data source
 */
export default class OrganizationProfile extends Organization {
  initialize() {
    this.urlRoot = '/organization_profiles';
  }

  parse(response: Object) {
    const organizationProfile = cloneDeep(response);
    organizationProfile['teachers'] = OrganizationProfileTeachers.fromJSON(
      organizationProfile['teachers']
    );
    return organizationProfile;
  }

  getStreet() {
    return this.get('street');
  }

  getCity() {
    return this.get('city');
  }

  getState() {
    return this.get('state');
  }

  getZip() {
    return this.get('zip');
  }

  getFormattedAddress() {
    return this.get('formatted_address');
  }

  getAddressObject() {
    return {
      line1: this.getStreet(),
      line2: [this.getCity(), this.getState(), this.getZip()]
        .filter(value => {
          return value;
        })
        .join(', '),
    };
  }

  getType() {
    return this.get('type');
  }

  getSubType() {
    return this.get('subtype');
  }

  getSubSubType() {
    return this.get('subsubtype');
  }

  getFormattedType() {
    return `${capitalize(this.getSubType())} ${this.getSubSubType() || ''}`;
  }

  getGradeLevel() {
    return this.get('grade_level');
  }

  getDistrictName() {
    return this.get('district_name');
  }

  getLatitude() {
    return this.get('latitude');
  }

  getLongitude() {
    return this.get('longitude');
  }

  getTeachers() {
    return this.get('teachers');
  }

  // quack like an Organization
  getMemberSampleString() {
    return '';
  }

  getMemberCount() {
    return 0;
  }

  getAdmins() {
    return [];
  }

  getUuid() {
    return this.get('uuid');
  }
}
